// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2qAds","label":"Completed_label__2gygk"};